import { ListActionTarget } from '../../../models/ListActionTarget';

export type AddToCartOrListState = {
    readonly target: ListActionTarget;
    readonly targetSelectionListId?: string;
};

export enum AddToCartOrListActionType {
    CHANGE_TARGET = 'CHANGE_TARGET',
    SET_TARGET_SELECTION_LIST_ID = 'SET_TARGET_SELECTION_LIST_ID'
}

export type AddToCartOrListActions = ChangeTarget | SetTargetSelectionListId;

export type ChangeTarget = {
    type: AddToCartOrListActionType.CHANGE_TARGET;
    target: ListActionTarget;
};

export type SetTargetSelectionListId = {
    type: AddToCartOrListActionType.SET_TARGET_SELECTION_LIST_ID;
    selectionListId: string;
};

export const addToCartOrListInitialState: AddToCartOrListState = {
    target: ListActionTarget.Cart,
    targetSelectionListId: undefined
};

export const addToCartOrListReducer = (
    state: AddToCartOrListState = addToCartOrListInitialState,
    action: AddToCartOrListActions
): AddToCartOrListState => {
    switch (action.type) {
        case AddToCartOrListActionType.CHANGE_TARGET: {
            return {
                ...state,
                target: action.target
            };
        }
        case AddToCartOrListActionType.SET_TARGET_SELECTION_LIST_ID: {
            return {
                ...state,
                targetSelectionListId: action.selectionListId
            };
        }
        default:
            return state;
    }
};
